import https from "./https";

const cyberbiz = {
  /**
   * 取得 Cyberbiz merchants 列表
   * @param {string} orgId - 組織 ID
   * @returns {Promise} - merchants 列表
   */
  getMerchants(orgId) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    return https.get(`/admin/organizations/${orgId}/cyberbiz/merchants`);
  },

  /**
   * 搜尋 Cyberbiz 顧客
   * @param {string} orgId - 組織 ID
   * @param {object} params - 搜尋參數
   * @returns {Promise} - 搜尋結果
   */
  searchCustomer(orgId, params) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    const searchParams = new URLSearchParams(params);

    return https.get(`/admin/organizations/${orgId}/cyberbiz?${searchParams}`);
  },

  /**
   * 查詢 Cyberbiz 訂單
   * @param {string} orgId - 組織 ID
   * @param {object} params - 查詢參數
   * @param {string} params.merchant_id - 商家 Hash ID（必填）
   * @param {string} [params.order_numbers] - 訂單編號，多筆以逗號分隔
   * @param {string} [params.order_id] - 訂單 ID（僅支援單筆）
   * @returns {Promise} - 訂單查詢結果
   */
  searchOrder(orgId, params) {
    if (!orgId) {
      return Promise.reject("orgId not found.");
    }
    if (!params.merchant_id) {
      return Promise.reject("merchant_id is required.");
    }
    if (!params.order_numbers && !params.order_id) {
      return Promise.reject("order_numbers or order_id is required.");
    }

    const searchParams = new URLSearchParams();
    searchParams.append("merchant_id", params.merchant_id);

    if (params.order_numbers) {
      searchParams.append("order_numbers", params.order_numbers);
    } else if (params.order_id) {
      searchParams.append("order_id", params.order_id);
    }

    return https.get(`/admin/organizations/${orgId}/cyberbiz/order?${searchParams}`);
  },

  /**
   * 匯入 Cyberbiz 會員等級調整 Excel
   * @param {string} orgId - 組織 ID
   * @param {object} params - 匯入參數
   * @param {string} params.merchant_id - 商家 Hash ID（必填）
   * @param {File} params.file - Excel 檔案（必填）
   * @returns {Promise} - 匯入結果
   */
  importCustomerLevels(orgId, params) {
    if (!orgId) {
      return Promise.reject("orgId not found.");
    }
    if (!params.merchant_id) {
      return Promise.reject("merchant_id is required.");
    }
    if (!params.file) {
      return Promise.reject("file is required.");
    }

    const formData = new FormData();
    formData.append("merchant_id", params.merchant_id);
    formData.append("file", params.file);

    return https.post(
      `/admin/organizations/${orgId}/cyberbiz-customer-level-import`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  /**
   * 匯入 Cyberbiz 會員標籤調整 Excel
   * @param {string} orgId - 組織 ID
   * @param {object} params - 匯入參數
   * @param {string} params.merchant_id - 商家 Hash ID（必填）
   * @param {File} params.file - Excel 檔案（必填）
   * @returns {Promise} - 匯入結果
   */
  importCustomerTags(orgId, params) {
    if (!orgId) {
      return Promise.reject("orgId not found.");
    }
    if (!params.merchant_id) {
      return Promise.reject("merchant_id is required.");
    }
    if (!params.file) {
      return Promise.reject("file is required.");
    }

    const formData = new FormData();
    formData.append("merchant_id", params.merchant_id);
    formData.append("file", params.file);

    return https.post(
      `/admin/organizations/${orgId}/cyberbiz-customer-tag-import`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};

export default cyberbiz;
